import React, { ChangeEvent, memo } from 'react';
import styled, { css } from 'styled-components';
import theme from '@styles/theme';

type StyledRadioProps = {
    radioId: string;
    label?: string;
    fontColor?: string;
    fontFamily?: string;
    margin?: string;
    name: string;
    value?: any;
    checked?: any;
    dataValue?: string;
    disabled?: boolean;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    flexOrder?: number;
    labelMargin?: string;
    width?: string;
};

const StyledRadio = ({
    radioId,
    label,
    margin,
    name,
    value,
    checked,
    onChange,
    dataValue = '',
    disabled,
    fontColor,
    flexOrder,
    labelMargin,
    width
}: StyledRadioProps) => {
    return (
        <Wrapper $margin={margin}>
            <Label htmlFor={radioId} $width={width}>
                <Marker $checked={value === checked} $order={flexOrder} />
                <Input
                    id={radioId}
                    type="radio"
                    name={name}
                    value={value}
                    onChange={onChange}
                    data-value={dataValue}
                    disabled={disabled}
                    checked={value === checked}
                />
                {label && (
                    <Text $fontColor={fontColor} $margin={labelMargin}>
                        {label}
                    </Text>
                )}
            </Label>
        </Wrapper>
    );
};

export default memo(StyledRadio);

const Wrapper = styled.div<{ $margin?: string }>`
    display: flex;
    align-items: center;
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;
const Label = styled.label<{ $width?: string }>`
    color: ${theme.colors.grayFontColor};
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: ${({ $width }) => ($width ? $width : 'auto')};
    cursor: pointer;
`;
const Marker = styled.div<{ $checked: boolean; $order?: number }>`
    order: ${({ $order }) => ($order ? $order : 0)};
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 5px solid ${theme.colors.ultraLightGrayFontColor};
    background-color: ${theme.colors.whiteColor};

    ${({ $checked }) =>
        $checked &&
        css`
            border: 5px solid ${theme.colors.pointGreen};
            background-color: ${theme.colors.whiteColor};
        `};
`;
const Input = styled.input`
    display: none;
`;
const Text = styled.div<{ $fontColor?: string; $margin?: string }>`
    margin: ${({ $margin }) => ($margin ? $margin : '0 0 0 12px')};
    font-size: 14px;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.grayFontColor};
`;
